export default __webpack_public_path__ + "5499f31b774ca683cc9fff1c884a58a5.png";